module.exports = __webpack_public_path__ + "images/assets/3c13a7db4112e5d8428da83de98d6320.svg";